import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import pages from './pages';
import iView from 'iview';

/** @namespace iView.LoadingBar */
/** @namespace iView.Message */

Vue.use(Router);
//创建Router实例
const router = new Router({
    history: false,
    routes: pages
});
// 不需要登陆的页面 - 路由名称
const noNeedLogin = ['login'];
router.beforeEach(async (to, from, next) => {
    iView.LoadingBar.start();
    /*if (to.name === 'login') {
        iView.LoadingBar.finish();
    }*/
    // 登陆验证
    if (!store.getters.userName && noNeedLogin.every(e => e !== to.name)) {
        store.dispatch('getUserInfo').then((res) => {
            //拦截无权限url
            if (!store.getters.isAdmin) {
                if (store.getters.auth.every(e => e.name !== to.name)) {
                    iView.Message.error('没有权限');
                    iView.LoadingBar.finish();
                    next('/');
                    return;
                }
            }
            next();
        }).catch(() => {
            iView.LoadingBar.finish();
            next('/login');
        });
        return;
    }

    // 登陆状态下屏蔽登陆页
    if (store.getters.userName && to.name === 'login') {
        iView.LoadingBar.finish();
        next('/');
        return;
    }

    // 拦截无权限菜单点击
    if (!store.getters.isAdmin && to.name != 'login') {
        if (store.getters.auth.every(e => e.name !== to.name)) {
            iView.Message.error('没有权限');
            iView.LoadingBar.finish();
            next('/login');
            return;
        }
    }

    // 正常执行
    next();
});

router.afterEach((to) => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

export default router;
